export function isMobile() {
  var userAgentInfo = navigator.userAgent

  var mobileAgents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod']

  var mobile_flag = false

  //根据userAgent判断是否是手机
  for (var v = 0; v < mobileAgents.length; v++) {
    if (userAgentInfo.indexOf(mobileAgents[v]) > 0) {
      mobile_flag = true
      break
    }
  }

  return mobile_flag
}

export function isWindow() {
  var userAgentInfo = navigator.userAgent

  if (userAgentInfo.indexOf('Mac') !== -1) {
    return false
  }

  return true
}
